<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.industryReportManagement') }}</span>
      </div>
      <div class="title-right">
        <el-input class="input-v2 input-round mr16 prefix-primary-color" v-model="queryParams.reportName" :placeholder="$t('reportsName')" suffix-icon="el-icon-search" @change="handleSearch"></el-input>
        <el-button type="primary" class="button-v2" @click="handleAdd">{{ $t('uploadReport') }}</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">{{ $t('handleEdit') }}</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">{{ $t('handleDelete') }}</span>
          </div>
        </template>
      </air-table>
  
      <bsp-pagination :pager-config.sync="pagerConfig" @page-change="pageChange"></bsp-pagination>
    </div>
    
    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="700px" append-to-body @closed="reset" v-dialog-drag>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" :label-width="lang == 'en' ? '170px' : '100px'" style="margin: 40px 0; padding: 0 30px;" size="small" label-suffix="：">
          <el-form-item class="fixed-height" :label="$t('reportName')" prop="reportName">
            <el-input v-model="form.reportName" :placeholder="$t('inputPlaceholder')" maxlength="2000" clearable />
          </el-form-item>
          <el-form-item :label="$t('reportCover')" prop="reportCoverId">
            <air-upload-file :file-list.sync="form.reportCoverArray" :file-ids.sync="form.reportCoverId" :multiple="false" :limit="1" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" v-if="modal.show"></air-upload-file>
          </el-form-item>
          <el-form-item :label="$t('reportFile')" prop="reportFileId">
            <air-upload-file :file-list.sync="form.reportFileArray" :file-ids.sync="form.reportFileId" :multiple="false" :limit="1" accept=".pdf" v-if="modal.show"></air-upload-file>
          </el-form-item>
          <el-form-item :label="$t('applicableIndustry')" prop="applicableIndustry">
            <bsp-select-tree :tree-data="treeSelectData" :default-checked.sync="form.applicableIndustry" super-id="-1" :props="propOptions" show-checkbox @selected="treeSelected" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modal.show = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
    
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import bspSelectTree from "@/components/bsp/bsp-select-tree/bsp-select-tree";
  import * as api from '@/api/policy/policyLibraryManagement';
  import * as apiA from '@/api/policy/policyLibrary';
  import { buildTree } from "@/util/commen";
  import { dictListFilter } from "@/filters";
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'IndustryReportManagement',
    components: {
      bspSelectTree
    },
    data() {
      return {
        loading: true,
        setIdByItemList: [],
        treeSelectData: [],
        propOptions: {
          parent: 'superId',
          value: 'codeItemId',
          label: 'codeItemName',
          children: 'children'
        },
        pagerConfig: {
          page: 1,
          limit: 20,
          total: 0
        },
        queryParams: {},
        total: 0,
        columns: [
          {title: this.$t('reportsName'), field: 'reportName', minWidth: 150},
          {title: this.$t('applicableIndustry'), field: 'applicableIndustryText', minWidth: 300}
        ],
        tableData: [],
        form: {},
        formRules: {
          reportName: [{ required: true, message: this.$t('inputPlaceholder'), trigger: 'blur' }],
          reportCoverId: [{ required: true, message: this.$t('pleaseUpload'), trigger: 'change' }],
          reportFileId: [{ required: true, message: this.$t('pleaseUpload'), trigger: 'change' }],
          applicableIndustry: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'change' }]
        },
        modal: {
          show: false,
          title: this.$t('handleEditReport'),
          edit: false
        },
        defaultGroupProps: {
          children: 'children',
          label: 'groupName',
          value: 'id',
        },
        payGroupDataList: [],
        submitLoading: false,
        confirmShow: false,
        confirmTitle: '',
        confirmContent: '',
        confirmFunction: undefined
      }
    },
    computed: {
      ...mapGetters(['lang', 'dicts'])
    },
    created() {
      this.init();
    },
    methods: {
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      },
      getSetIdByItemList() {
        return new Promise((resolve, reject) => {
          let params = {
            setList: 1013
          }
          apiA.setIdByItemList(params)
            .then(res => {
              this.setIdByItemList = res.data.data;
              const treeSelectData = buildTree(JSON.parse(JSON.stringify(this.setIdByItemList)), 'codeItemId', 'superId');
              this.treeSelectData = treeSelectData;
              resolve(true);
            })
            .catch(error =>{
              this.setIdByItemList = [];
              this.treeSelectData = [];
              reject(error);
            })
        })
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfig.page = 1;
        }
        this.getData();
      },
      init() {
        this.getSetIdByItemList()
          .then(() => {
            this.getData();
          })
          .catch(error => {
            this.loading = false;
          })
      },
      getData() {
        this.loading = true
        const { page, limit } = this.pagerConfig;
        let params = {
          pageNum: page,
          pageSize: limit,
          ...this.queryParams
        }
        api.reportList(params)
          .then(res => {
            let { list, total } = res.data.data;
            list = JSON.parse(JSON.stringify(list));
            list.forEach(item => {
              if (item.applicableIndustry && item.applicableIndustry.split(',').length > 0) {
                let applicableIndustryCode = item.applicableIndustry.split(',');
                let applicableIndustryText = [];
                applicableIndustryCode.forEach(subItem => {
                  if (subItem) {
                    applicableIndustryText.push(dictListFilter(subItem, this.setIdByItemList));
                  }
                })
                item.applicableIndustryText = applicableIndustryText.join('，');
              }
            })
            this.tableData = list;
            this.pagerConfig.total = res.data.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
          })
      },
      // 搜索
      handleSearch() {
        this.pagerConfig.page = 1;
        this.getData();
      },
      reset() {
        this.form = {};
        this.modal.edit = false;
        this.resetForm('form');
      },
      handleAdd() {
        this.modal.title = this.$t('handleCreateReport');
        this.$nextTick(() => {
          this.modal.show = true;
        })
      },
      // 编辑
      handleEdit(row) {
        this.form = {
          ...row
        }
        this.modal.title = this.$t('handleEditReport');
        this.modal.edit = true;
        this.modal.show = true;
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            const fn = this.modal.edit ? api.reportUpdate: api.reportAdd;
            const { id, reportName, reportCoverId, reportFileId, applicableIndustry } = this.form;
            const params = {
              id,
              reportName,
              cover: reportCoverId,
              file: reportFileId,
              applicableIndustry
            }
            fn(params).then(res => {
              if (res.data.code === 0) {
                this.getData();
                this.modal.show = false
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      },
      // 删除
      handleDelete(item) {
        this.confirmShow = true
        this.confirmTitle = this.$t('handleDeleteReport');
        this.confirmContent = `${ this.$t('sureDeleteReport') }「${item.reportName}」?`
        this.confirmFunction = () => {
          api.reportDel({ id: item.id }).then(() => {
            this.getData()
            this.$msgSuccess('删除成功')
          })
        }
      },
      // 选中树结构
      treeSelected({ keys, labels }) {
        this.$set(this.form, 'applicableIndustry', keys);
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
